module.exports = __webpack_public_path__ + "img/thesis-grey.0ca284b5.svg";